<template>
  <div class="kstages">
    <div class="kstages__row">
      <div class="kstages__side">
        <div class="kstages__stage">1 · Quarry block, Sardinia</div>
        <div class="kstages__loc">Scarraciana, near Tempio Pausania · 20 Oct 1983</div>
      </div>
      <div class="kstages__bar kstages__bar--start" style="--w: 100%"><span class="kstages__mass">500 t</span></div>
    </div>
    <div class="kstages__arrow"><span class="kstages__loss">−320 t</span><span class="kstages__how">blasted off on site, to specification, per Bill\'s drawing</span></div>

    <div class="kstages__row">
      <div class="kstages__side">
        <div class="kstages__stage">2 · Transport block</div>
        <div class="kstages__loc">to Marina di Carrara · 20 Feb 1984</div>
      </div>
      <div class="kstages__bar kstages__bar--mid" style="--w: 36%"><span class="kstages__mass">180 t</span></div>
    </div>
    <div class="kstages__arrow"><span class="kstages__loss">−100 t</span><span class="kstages__how">carved off by hand and diamond wire across 2½ years — Stroobant directs the crew</span></div>

    <div class="kstages__row">
      <div class="kstages__side">
        <div class="kstages__stage">3 · Hand-finished sculpture</div>
        <div class="kstages__loc">leaves Marina di Carrara in a steel corset · Aug 1986</div>
      </div>
      <div class="kstages__bar kstages__bar--final" style="--w: 16%"><span class="kstages__mass">80 t</span></div>
    </div>
    <div class="kstages__arrow"><span class="kstages__how">shipped via Gibraltar → Rotterdam → Rhine → Main</span></div>

    <div class="kstages__row">
      <div class="kstages__side">
        <div class="kstages__stage">4 · Installed in Frankfurt</div>
        <div class="kstages__loc">Taunusanlage · in front of Deutsche Bank · 7 Sept 1986</div>
      </div>
      <div class="kstages__bar kstages__bar--final" style="--w: 16%"><span class="kstages__mass">80 t</span></div>
    </div>

    <div class="kstages__summary">
      <div class="kstages__sum-num">−84<span class="kstages__sum-u">%</span></div>
      <div class="kstages__sum-txt">
        <strong>420 of the original 500 tons</strong> ended up on the workshop floor.<br />
        What remained is the largest granite monolith carved since antiquity.
      </div>
    </div>
  </div>
</template>

<style scoped>
.kstages {
  border-top: 1px solid var(--vein);
  margin: 1.4rem 0;
}
.kstages__row {
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 1.6rem;
  padding: 0.5rem 0;
  align-items: center;
}
.kstages__side .kstages__stage {
  font-family: var(--font-body);
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--slate);
  line-height: 1.2;
}
.kstages__side .kstages__loc {
  font-size: 0.86rem;
  color: var(--granite);
  margin-top: 0.2rem;
}
.kstages__bar {
  width: var(--w);
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 1rem;
  border-radius: 2px;
  position: relative;
}
.kstages__bar--start { background: var(--paper-deep); border: 2px solid var(--slate); }
.kstages__bar--mid { background: var(--granite); }
.kstages__bar--final { background: var(--accent); }
.kstages__mass {
  font-family: var(--font-body);
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--slate);
}
.kstages__bar--mid .kstages__mass,
.kstages__bar--final .kstages__mass { color: var(--paper); }

.kstages__arrow {
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 1.6rem;
  padding: 0.4rem 0;
}
.kstages__loss {
  font-family: var(--font-body);
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--accent-deep);
  text-align: right;
}
.kstages__how {
  font-size: 0.92rem;
  color: var(--granite);
  font-style: italic;
  padding-left: 1.4rem;
  border-left: 2px dashed var(--accent);
}

.kstages__summary {
  margin-top: 1.6rem;
  padding: 1.4rem 1.6rem;
  background: rgba(194, 90, 58, 0.06);
  border: 1px solid var(--accent);
  border-radius: 4px;
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 1.6rem;
  align-items: center;
}
.kstages__sum-num {
  font-family: var(--font-body);
  font-size: clamp(3rem, 5vw, 4.6rem);
  font-weight: 700;
  color: var(--accent);
  line-height: 0.9;
}
.kstages__sum-u { font-size: 0.5em; color: var(--accent-deep); }
.kstages__sum-txt { font-size: 1.04rem; line-height: 1.55; color: var(--slate-soft); }
.kstages__sum-txt strong { color: var(--slate); font-weight: 600; }

@media (max-width: 900px) {
  .kstages__row, .kstages__arrow { grid-template-columns: 1fr; gap: 0.4rem; }
  .kstages__loss { text-align: left; }
  .kstages__how { padding-left: 0.8rem; }
  .kstages__summary { grid-template-columns: 1fr; gap: 0.8rem; }
}
</style>
